import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { Sparkle } from "@/components/ACGDecor";

interface CRTStaticProps {
  active: boolean;
}

// Channel-switch overlay. Per spec #4: 200-350ms total.
// Uses the classic B站 22娘跑步 GIF as the centerpiece — the most iconic
// B站 visual element. Composed of:
//   - Noise burst (CSS noise, ~150ms)
//   - Centered 22娘跑步 GIF (the classic B站 loading mascot)
//   - Sparkle bursts around the running girl
//   - CHANGING CHANNEL VFD text
//   - Horizontal scanline sweep

export default function CRTStatic({ active }: CRTStaticProps) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (active) setShown(true);
    else {
      const id = setTimeout(() => setShown(false), 320);
      return () => clearTimeout(id);
    }
  }, [active]);

  return (
    <AnimatePresence>
      {shown && (
        <motion.div
          className="absolute inset-0 z-[60] pointer-events-none overflow-hidden bg-void"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.08 }}
        >
          {/* Static noise layer */}
          <div className="crt-noise-layer" />

          {/* Horizontal scanline sweep */}
          <motion.div
            className="absolute inset-x-0 h-20 bg-gradient-to-b from-transparent via-signal/30 to-transparent pointer-events-none"
            initial={{ y: "-100%" }}
            animate={{ y: "200%" }}
            transition={{ duration: 0.3, ease: "linear" }}
          />

          {/* Centered 小电视抖动 GIF */}
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.15 }}
              className="relative"
            >
              <img
                src="/loading-2233.gif"
                alt="换台中"
                width={196}
                height={156}
                className="block"
              />
              {/* 22娘周围的 sparkle */}
              <Sparkle size={18} color="#FFD166" delay={0} className="absolute -top-2 -left-4" />
              <Sparkle size={14} color="#73B3D8" delay={0.15} className="absolute -top-1 -right-4" />
              <Sparkle size={16} color="#F5A3C8" delay={0.3} className="absolute -bottom-2 left-1/2 -translate-x-1/2" />
            </motion.div>

            <motion.div
              className="vfd text-sm sm:text-base tracking-widest2"
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 1, 0.7] }}
              transition={{ duration: 0.3, times: [0, 0.2, 0.6, 1] }}
            >
              CHANGING CHANNEL
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}